import React, { PureComponent } from "react";
import { fieldGenerator } from "utilities/form";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants/index";
import PropTypes from "prop-types";
import { DocumentViewer } from "components/index";
import { List, Icon, Form, Card, Button, Checkbox, Badge, message, Modal, Select } from "antd";
import _trim from "lodash/trim";
import CompanyLosService from "../services/company-los-services";
import { REJECT_REASONS } from 'constants/index';

class CompanyInvoiceFormList extends PureComponent {
    state = {
        currentImageIndex: 0,
        checkedInvoiceIds: [],
        allChecked: false,
        buyerGstin: {},
        anchorList: [],
        dealerCodeListData: [],
        initialLoadCount: 20, // Number of items to load initially
        loadMoreCount: 20, // Number of items to load with each scroll
        showRejectModal: false,
        selectedRejectReason: null,
        rejectInvoiceId: null,
        rejectLoader: false,

    };

    componentDidMount() {
        let fieldObj = {};
        if (this.props.dealerCodes && this.props.dealerCodes.data && this.props.dealerCodes.data.length) {
            this.props.dealerCodes.data.map(_ => fieldObj[_.gstin] = { dealer_codes: _.dealer_codes, display_name: _.display_name });
            this.setState({
                buyerGstin: fieldObj,
                dealerCodeListData: this.props.dealerCodes?.data
            }, () => {
                this.setSelectedFields();
            });
        } else {
            if (this.props.values.toJS()[0]?.seller_gstin) {
                CompanyLosService.getDealers(this.props.values.toJS()[0]?.seller_gstin).then((data) => {
                    data.data.map(_ => fieldObj[_.gstin] = { dealer_codes: _.dealer_codes, display_name: _.display_name });
                    this.setState({
                        buyerGstin: fieldObj,
                        dealerCodeListData: data?.data
                    }, () => {
                        this.setSelectedFields();
                    });
                }).catch((err) => {
                    console.error("---> ", err);
                });

                // CompanyLosService.getSellerWiseAnchorList(this.props.values.toJS()[0]?.seller_gstin).then((data) => {
                //     this.setState({
                //         anchorList: data.data
                //     });
                // }).catch((err) => {
                //     console.error("---> ", err);
                // });
            }
        }
    }

    setSelectedFields = () => {
        const { buyerGstin } = this.state;
        this.props.values.map((_, k) => {
            this.props.form.setFieldsValue({
                [`[${k}].buyer_name_display`]: buyerGstin[_.buyer_gstin] ? _.buyer_gstin : "",
            });
        });
    }

    amountChange = (_, val) => {
        this.props.form.setFieldsValue({
            [`[${_}].amount`]: val,
            [`[${_}].principal_amount`]: val
        });
    }

    getFormFields = (principal_amount_validator) => {
        return new OrderedMap({
            "file_url": {
                labelProp: "file_url",
                className: "d-none",
                category: 1
            },
            "file_name": {
                labelProp: "file_name",
                className: "d-none",
                category: 1
            },
            "file_size": {
                labelProp: "file_size",
                className: "d-none",
                category: 1
            },
            "id": {
                labelProp: "id",
                className: "d-none",
                category: 1
            },
            "is_verified": {
                labelProp: "is_verified",
                className: "d-none",
                category: 1
            },
            "invoice_no": {
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0 w-100",
                placeholder: "Invoice no.",
                showSearch: true,
                labelProp: "invoice_no",
                rules: [
                    {
                        required: true,
                        message: "invoice no is required"
                    }
                ],
                label: "Invoice no",
                category: 2,
                size: "small",

            },
            "invoice_date": {
                type: INPUT_TYPES.DATE,
                className: "form-field mr-10 mb-0 w-100",
                placeholder: "(YYYY-MM-DD)",
                showSearch: true,
                labelProp: "invoice_date",
                rules: [
                    {
                        required: true,
                        message: "invoice date is required"
                    }
                ],
                label: "Invoice date",
                category: 2,
                // size: "small",

            },
            "amount": {
                type: INPUT_TYPES.NUMBER,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice amount",
                labelProp: "amount",
                rules: [
                    {
                        required: true,
                        message: "invoice amount is required"
                    }
                ],
                label: "Invoice amount",
                category: 3,
                // size: "small",

            },
            "principal_amount": {
                type: INPUT_TYPES.NUMBER,
                className: "form-field mr-10 mb-0",
                placeholder: "Principal amount",
                labelProp: "principal_amount",
                rules: [
                    {
                        required: true,
                        message: "funded amount is required",
                    },
                    principal_amount_validator
                ],
                label: "Principal amount",
                category: 3,

            },
            "buyer_name_display": {
                type: INPUT_TYPES.SELECT,
                label: "Buyer Name",
                className: "form-field mr-10 mb-0 equalWidthCol ",
                showSearch: true,
                placeholder: "Buyer",
                options: [],
                rules: [],
                category: 5,
                filterOption: (inputValue, option) => {
                    if (option.props.children.toLowerCase().includes(inputValue.toLowerCase())) {
                        return true;
                    }
                },
                allowClear: "false"
            },
            "buyer_gstin": {
                labelProp: "buyer_gstin",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0 equalWidthCol",
                placeholder: "buyer GSTIN",
                rules: [
                    {
                        required: true,
                        message: "buyer gstin is required",
                    }
                ],
                onChange: this.onBuyerGstin,
                label: "Buyer GSTIN",
                category: 5,
                size: "small",

            },
            "dealer_code": {
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0 flex-1",
                style: {
                    minWidth: "auto",
                    maxWidth: 266
                },
                placeholder: "Dealer Code",
                rules: [],
                options: [],
                label: "Dealer Code",
                category: 4,
            },
            "primary_brands": {
                labelProp: "primary_brands",
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0",
                mode: "single",
                options: [],
                rules: [
                    {
                        required: true,
                        message: "primary brand is required",
                    }
                ],
                disabled: true,
                label: "Primary Brands",
                size: "small",

            },
            "cases": {
                labelProp: "cases",
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0",
                mode: "multiple",
                options: [],
                disabled: true,
                label: "Cases",
                size: "small",

            },
            "seller_gstin": {
                labelProp: "seller_gstin",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "seller GSTIN",
                disabled: true,
                label: "Seller GSTIN",
                category: 4,
                size: "small",
            },
            // "anchor_gstin": {
            //     labelProp: "anchor_gstin",
            //     type: INPUT_TYPES.SELECT,
            //     className: "form-field mr-10 mb-0",
            //     options: [],
            //     rules: [
            //         {
            //             required: true,
            //             message: "anchor is required"
            //         }
            //     ],
            //     disabled: true,
            //     label: "Anchor",
            //     size: "small",

            // },
            "tenor": {
                labelProp: "tenor",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Tenor",
                label: "Tenor",
                category: 6,
                size: "small",
                rules: [
                    {
                        required: true,
                        message: "Tenor is required"
                    },
                ],
            },
            "invoice_tenure": {
                labelProp: "invoice_tenure",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice Tenure",
                disabled: true,
                label: "Invoice Tenure",
                category: 4,
                size: "small",
            },
            "invoice_roi": {
                labelProp: "invoice_roi",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice ROI",
                disabled: true,
                label: "Invoice ROI",
                category: 4,
                size: "small",
            }
        });
    }

    formFields = () => this.getFormFields(
        {
            validator: (rules, value, callback) => {
                const amountVal = Object.values(this.props.form.getFieldsValue()).find(el => el.principal_amount == value).amount;
                if ((Number(value) > Number(amountVal)) || Number(value) <= 0 || Number(amountVal) <= 0) {
                    console.log("inside validation");
                    // callback("Disbursal amount cannot be greater than Invoice amount");
                    // const amount = (this.props.form.getFieldValue([`[${_}].amount`]) || {}).amount;
                    // if (value > amount) {
                    //     callback("Disbursal amount cannot be greater than Invoice amount");
                } else {
                    callback();
                }
            }
        }
    );
    fieldGenerator = fieldGenerator.bind(this.props.form);

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, data) => {
                if (this.props.isChecker) {
                    if (!err) {
                        let isFinalSubmit = false;
                        if (Object.values(data).find(el => Number(el.tenor) < 15 || Number(el.tenor) > 90)) {
                            message.error("Please enter correct tenor");
                            return;
                        }
                        const checkedInvoices = new OrderedMap(this.props.form.getFieldsValue()).map(_ =>
                            _
                        )
                            .toList()
                            .toArray()
                            .filter(_ =>
                                _.is_verified || this.state.checkedInvoiceIds.includes(_.id)).length;
                        if (checkedInvoices === this.props.values.size) {
                            isFinalSubmit = true;
                        }
                        this.props.invoiceValuesSubmit(new OrderedMap(data).map(_ =>
                            _
                        )
                            .toList()
                            .toArray()
                            .filter(_ =>
                                this.state.checkedInvoiceIds.includes(_.id))
                            .map(_ => {
                                if (!this.checkBuyerNameSelected(_.buyer_name_display)) {
                                    delete (_.buyer_name_display);
                                } else {
                                    _.buyer_name_display = this.state.buyerGstin[_.buyer_name_display].display_name;
                                }
                                delete (_.buyer_name);
                                if (!_.dealer_code) {
                                    delete (_.dealer_code);
                                }
                                return ({
                                    ..._,
                                    is_verified: true,
                                    invoice_no: _trim(_.invoice_no, " "),
                                    amount: Number(_.amount),
                                    principal_amount: Number(_.principal_amount),
                                    seller_gstin: _trim(_.seller_gstin, " "),
                                    buyer_gstin: _trim(_.buyer_gstin, " "),
                                    anchor_gstin: _.primary_brands
                                });
                            }), isFinalSubmit);
                        this.setState({
                            checkedInvoiceIds: []
                        });
                    }
                } else {
                    if (!err) {
                        this.props.invoiceValuesSubmit(new OrderedMap(data).map(_ =>
                            _
                        ).toList().toArray().map(_ => {
                            if (!this.checkBuyerNameSelected(_.buyer_name_display)) {
                                delete (_.buyer_name_display);
                            } else {
                                _.buyer_name_display = this.state.buyerGstin[_.buyer_name_display].display_name;
                            }
                            delete (_.buyer_name);

                            if (!_.dealer_code) {
                                delete (_.dealer_code);
                            }
                            return ({
                                ..._,
                                invoice_no: _trim(_.invoice_no, " "),
                                amount: Number(_.amount),
                                principal_amount: Number(_.principal_amount),
                                seller_gstin: _trim(_.seller_gstin, " "),
                                buyer_gstin: _trim(_.buyer_gstin, " "),
                                anchor_gstin: _.primary_brands
                            });
                        }));
                        // this.props.finalSubmission("maker");
                    }
                }
            });
        }
    };

    checkBuyerNameSelected = (buyer_display_name) => {
        if (!buyer_display_name || !this.state.buyerGstin[buyer_display_name]) return false;
        return true;
    }

    onRemove = invoiceId => {
        this.props.form.validateFields((err, data) => {
            this.props.onRemove(invoiceId, new OrderedMap(data).mapEntries(([, v]) => ([v.id, v])).filter((_, k) => k !== invoiceId).toList().toArray());
        });
    }

    selectImageIndex = _ => {
        this.setState({
            currentImageIndex: _
        });
    }

    checkAll = () => {
        if (this.state.allChecked) {
            this.setState({
                checkedInvoiceIds: [],
                allChecked: false
            });
        } else {
            this.setState({
                allChecked: true,
                checkedInvoiceIds: this.props.values.map(_ => (_.id)).toJS()
            });
        }
    }

    getTotalInvoiceAmount = () => {
        const initialAmount = (this.props.values || []).reduce((agg, val) => {
            return agg + +val?.principal_amount;
        }, 0);
        const totalAmount = new OrderedMap(this.props.form.getFieldsValue()).map(_ => _).toList().toArray().reduce((agg, val) => {
            return agg + +val?.principal_amount;
        }, 0);
        return totalAmount || initialAmount || 0;
    }

    getSelectedInoiceAmount = () => {
        const initialAmount = (Object.values(this.props.form?.getFieldsValue()).filter(_ => this.state.checkedInvoiceIds.includes(_.id)) || []).reduce((agg, val) => {
            return agg + +val.principal_amount;
        }, 0);
        return initialAmount;
    }

    renderHeader = () => {
        const pendingInvoices = this.props.values.filter(_ => _.invoice_status === "pending").size > 0;
        return (
            <div className={"d-flex flex-row justify-content-space-between"}>
                <div className={"d-flex flex-row align-items-center"}>
                    {(this.props.isChecker && this.props.values.size !== this.props.values.filter(_ => _.is_verified).size) &&
                    pendingInvoices &&
                        <Checkbox
                            className={"mr-5"}
                            // indeterminate={this.state.checkedInvoiceIds.length}
                            onChange={this.checkAll}
                            checked={this.state.checkedInvoiceIds.length == this.props.values.size}
                        >All</Checkbox>
                    }
                    <div className={"d-flex flex-column"}>
                        <span>Total - {this.props.values.size} invoices of ₹{this.getTotalInvoiceAmount()}</span>
                        <span>Selected - {this.state.checkedInvoiceIds.length} invoices of ₹{this.getSelectedInoiceAmount()}</span>
                    </div>
                </div>
                <div
                    className={
                        "pb-10 d-flex justify-content-flex-end"
                    }>
                    {this.props.isEditable && pendingInvoices && <Button disabled={this.isApprovedDisabled()} type="primary" htmlType={"submit"}>
                        {this.props.loading ? (
                            <Icon type={"loading"} />
                        ) : null}
                        {this.props.isChecker ? "Approve" : "Submit"}
                    </Button>}
                </div>
            </div>
        );
    };
    getFormFiels = (updatedFormData, _, data, item) => {
        let fields = this.formFields(null);
        let bizongoGSTIN = "27AAVCS6045D1Z0";
        if (updatedFormData[data]) {
            let inputGstin = updatedFormData[data].buyer_gstin && updatedFormData[data].buyer_gstin.toUpperCase();
            if (this.state.buyerGstin[inputGstin] && !this.state.buyerGstin[inputGstin].dealer_codes.length) {
                fields = fields.delete("dealer_code");
            }
            if (item["program_anchor_gstin"] == null || (Object.values(updatedFormData)[0] && (item["program_anchor_gstin"] !== bizongoGSTIN || this.props.history?.location?.state?.tenorOnUpload))) {
                fields = fields.delete("tenor");
            }
        }
        return fields;
    }

    onBuyerGstChange = (_, e) => {
        const { buyerGstin } = this.state;
        let input = e.target.value.toUpperCase();
        let updatedFormData = this.props.form.getFieldsValue();
        if (updatedFormData[_] && buyerGstin[input]) {
            this.props.form.getFieldDecorator([`[${_}].buyer_name_display`]);
            this.props.form.setFieldsValue({
                [`[${_}].dealer_code`]: this.state.buyerGstin[e.target.value]?.dealer_codes[0],
                [`[${_}].buyer_name_display`]: input
            });
        } else {
            this.props.form.setFieldsValue({
                [`[${_}].dealer_code`]: "",
                [`[${_}].buyer_name_display`]: "GSTIN not linked"
            });
        }
    }

    selectBuyer = (buyer, item) => {
        let updatedFormData = this.props.form.getFieldsValue();
        let data = Object.keys(updatedFormData).filter(_ => updatedFormData[_].id === item.id);

        if (updatedFormData[data]) {
            this.props.form.setFieldsValue({
                [`[${data}].dealer_code`]: "",
                [`[${data}].buyer_gstin`]: buyer,
                [`[${data}].buyer_name_display`]: buyer
            });
        } else {
            this.props.form.setFieldsValue({
                [`[${data}].dealer_code`]: "",
                [`[${data}].buyer_name_display`]: "GSTIN not linked"
            });
        }
    }


    renderForm = (item, _) => {
        let updatedFormData = this.props.form.getFieldsValue();
        let data = Object.keys(updatedFormData).filter(_ => updatedFormData[_]?.id === item?.id);
        const fieldsVal = this.props.values && this.props.values.toJS()[0] && this.props.values.toJS()[0].comparative_data;
        const fieldsObj = {
            "invoice_no": "invoice_no",
            "invoice_date": "invoice_date",
            "amount": "invoice_amount",
            "principal_amount": "invoice_amount",
            "buyer_gstin": "buyer_gstin",
        };
        return (
            <div className={"w-100"}>{
                this.getFormFiels(updatedFormData, _, data, item)
                    .groupBy(__ => __.category)
                    .map((__, category) => {
                        if (category !== 1) {
                            return (<div className={"w-100 d-flex justify-content-flex-start mb-5"} offset={(category === 3 || category === 4) ? 1 : 0} key={category}>
                                {__.map((field, fieldName) => {
                                    if ((fieldsVal && Object.keys(fieldsVal).length > 0 && fieldsObj && fieldsObj[fieldName])) {
                                        field.helpMessage = fieldsObj && fieldsObj[fieldName] && fieldsVal[fieldsObj[fieldName]] && fieldsVal[fieldsObj[fieldName]].is_edited_by_maker && "Edited by seller";
                                        field.className = field.className + fieldsObj && fieldsObj[fieldName] && fieldsVal[fieldsObj[fieldName]] && fieldsVal[fieldsObj[fieldName]].is_edited_by_maker && " invoiceFieldColor";
                                    }
                                    if (fieldName === "principal_amount") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => el.principal_amount > el.amount);
                                        let filteredArrayNonPositives = Object.values(updatedFormData).filter(el => el.principal_amount <= 0);
                                        if (filteredArray.length > 0 && filteredArray.find(el => Number(el.principal_amount) > Number(el.amount) && el.id == item?.id)) {
                                            field.helpMessage = "Principal amount cannot be greater than Invoice amount";
                                        }
                                        if (filteredArrayNonPositives.length > 0 && filteredArrayNonPositives.find(el => Number(el.principal_amount) <= 0 && el.id == item?.id)) {
                                            field.helpMessage = "Principal amount cannot be <= 0";
                                        }
                                    }
                                    if (fieldName === "amount") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => el.amount <= 0);
                                        if (filteredArray.length > 0 && filteredArray.find(el => Number(el.amount) <= 0 && el.id == item?.id)) {
                                            field.helpMessage = "Invoice amount cannot be <= 0";
                                        }
                                    }
                                    if (fieldName === "tenor") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => Number(el.tenor) < 15 || Number(el.tenor) > 90);
                                        if (filteredArray.length > 0 && filteredArray.find(el => (Number(el.tenor) < 15 || Number(el.tenor) > 90) && el.id == item?.id)) {
                                            field.helpMessage = "Tenor should be between 15 and 90";
                                        }
                                    }
                                    if (fieldName === "dealer") {
                                        field.onSearch = this.onDealerSearch;
                                        field.onSelect = this.setDealer;
                                        field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                    } else if (fieldName === "seller_gstin") {
                                        field.disabled = true;
                                    } else if (fieldName === "dealer_code") {
                                        if (updatedFormData[data]) {
                                            let currentGstin = updatedFormData[data].buyer_gstin && updatedFormData[data].buyer_gstin.toUpperCase();
                                            field.options = this.state.buyerGstin[currentGstin] ? this.state.buyerGstin[currentGstin].dealer_codes.map(_ => ({
                                                label: _,
                                                value: _
                                            })) : [];
                                            // field.rules = [
                                            //     {
                                            //         required: true,
                                            //         message: "Dealer Code is required"
                                            //     },
                                            // ];
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        }
                                    } else {
                                        field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                    }

                                    if (fieldName === "buyer_name_display") {
                                        if (updatedFormData[data]) {
                                            field.options = Map(this.state.buyerGstin).map((_, k) => ({
                                                label: _.display_name,
                                                value: k
                                            })).toList().toJS();
                                            field.onSelect = (buyer) => this.selectBuyer(buyer, item);
                                        }
                                    }
                                    if (fieldName === "buyer_gstin") {
                                        field.onChange = this.onBuyerGstChange.bind(null, _);
                                    }
                                    if (fieldName === "primary_brands") {
                                        let filterdAnchorlist = this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin) && this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin).length && this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin)[0];

                                        field.options = filterdAnchorlist?.anchor_list && filterdAnchorlist?.anchor_list?.length > 0 && filterdAnchorlist?.anchor_list?.map(_ => ({
                                            label: _.name,
                                            value: _.gstin
                                        }))
                                    }
                                    if (fieldName === "amount") {
                                        field.onChange = this.amountChange.bind(null, _);
                                    }
                                    return this.fieldGenerator(`[${_}].${fieldName}`, field)();
                                }).toList()}
                            </div>);
                        } else {
                            return (
                                <div className={"w-100"} key={category}>
                                    {__.map((field, fieldName) => {
                                        if (fieldName === "dealer") {
                                            field.onSearch = this.onDealerSearch;
                                            field.onSelect = this.setDealer;
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        } else if (fieldName === "seller_gstin") {
                                            field.disabled = true;
                                        } else {
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        }
                                        return this.fieldGenerator(`[${_}].${fieldName}`, field)();
                                    }).toList()}
                                </div>
                            );
                        }
                    })
                    .toList()}
            </div>);
    };

    checkCheckBox = _ => {
        if (this.state.checkedInvoiceIds.includes(_)) {
            this.setState({
                checkedInvoiceIds: this.state.checkedInvoiceIds.filter(id => id !== _)
            });
        } else {
            this.setState({
                checkedInvoiceIds: [...this.state.checkedInvoiceIds, _]
            });
        }
    }
    statusMap = {
        auto_approved: "Auto Approved",
        manual_approved: "Manual Approved",
        rejected: "Rejected",
        pending: "Pending",
    }

    openRejectModal = invoiceId => {
        this.setState({
            showRejectModal: true,
            rejectInvoiceId: invoiceId,
            selectedRejectReason: null,
        });
    };

    submitReject = () => {
        const { rejectInvoiceId, selectedRejectReason } = this.state;
        if (!rejectInvoiceId || selectedRejectReason === null) {
            return;
          }
        this.setState({ rejectLoader: true });

        this.props.form.validateFields((err, data) => {
            if (err) {
                this.setState({ rejectLoader: false });
                return;
              }
            this.props.onRemove(rejectInvoiceId, new OrderedMap(data).mapEntries(([, v]) => ([v.id, v])).filter((_, k) => k !== rejectInvoiceId).toList().toArray(), selectedRejectReason);
            
            this.setState({
                rejectLoader: false,
                showRejectModal: false,
                selectedRejectReason: null,
                rejectInvoiceId: null,
            });
        });
    };

    closeRejectModal = () => {
        this.setState({
            showRejectModal: false,
            selectedRejectReason: null,
            rejectInvoiceId: null,
        });
    };


    renderListItem = (_, k) => {
        return (
            <List.Item
                onClick={() => this.selectImageIndex(k)}
                className={
                    "cursor-pointer border-none d-flex flex-column mb-5 bg-white"
                }
                style={{ background: k === this.state.currentImageIndex ? "#e7e7e7" : "#fff" }}
            >
                <div className={"fb-100 w-100 d-flex flew-row align-items-center justify-content-space-between"}>
                    {(this.props.isChecker && !_.is_verified && _.invoice_status === "pending") &&
                        <Checkbox
                            disabled={_.is_verified}
                            onChange={() => this.checkCheckBox(_.id)}
                            checked={_.is_verified || this.state.checkedInvoiceIds.includes(_.id)}
                        />
                    }
                    <Icon
                        style={{ fontSize: "28px", color: "#08c", marginLeft: "10px" }}
                        theme="outlined"
                        type={"file-pdf"}
                    />
                    <div className={"p-5"}>
                        {/* {(this.props.isChecker && _.is_verified) && 
                            <span style={{color: "green"}}>Approved</span>
                        } */}
                        {(this.props.isChecker && `${_.invoice_status !== "rejected" ? _.is_verified : null}`) && <Badge
                            key={k}
                            style={{ backgroundColor: `${_.invoice_status == "rejected" ? "red" : "#52c41a"}` }}
                            count={this.statusMap[_.invoice_status] || "--"}
                        />}
                        <h4>{_.file_name}</h4>
                    </div>
                    <div>
                        <span className={"mr-5"}>{_.file_size} bytes</span>
                    </div>
                    {/* {(this.props.isChecker && !_.is_verified && _.invoice_status == "pending") && <span onClick={() => this.onRemove(_.id)} style={{ color: "#F15642", alignItems: "flex-end" }}>Reject</span>} */}
                    {(this.props.isChecker && !_.is_verified && _.invoice_status == "pending") && <span onClick={() => this.openRejectModal(_.id)} style={{ color: "#F15642", alignItems: "flex-end" }}>Reject</span>}
                </div>
                <div className={"fb-100 w-100"}>
                    <div
                        className={
                            "form-row w-100 fb-100 d-flex flex-row align-items-center"
                        }>
                        {this.renderForm(_, k)}
                    </div>
                </div>
            </List.Item>
        );
    };

    isApprovedDisabled = () => {
        if (this.props.isChecker) {
            return this.state.checkedInvoiceIds.length === 0;
        }
        return false;
    }

    // onApprove = () => {

    // }

    handleLoadMore = () => {
        this.setState(prevState => ({
            initialLoadCount: prevState.initialLoadCount + this.state.loadMoreCount,
        }));
    };

    render() {
        return (
            <>
                <Modal
                    visible={this.state.showRejectModal}
                    title="Reject Invoice"
                    onCancel={this.closeRejectModal}
                    footer={[
                        <Button key="cancel" onClick={this.closeRejectModal}>
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={this.state.rejectLoader}
                            disabled={this.state.selectedRejectReason === null}
                            onClick={this.submitReject}
                        >
                            Submit
                        </Button>,
                    ]}
                >
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Select reject reason"
                        value={this.state.selectedRejectReason}
                        onChange={value => this.setState({ selectedRejectReason: value })}
                    >
                        {[...REJECT_REASONS].map(([label, value]) => (
                            <Select.Option key={label} value={value}>
                                {label}
                            </Select.Option>
                        ))}
                    </Select>
                </Modal>

                <Form onSubmit={this.onValuesSubmit}>
                    <Form.Item className={"mb-10 invoice-list-form"}>
                        <div
                            className={"ph-20 d-flex justify-content-space-between"}>
                            <List
                                border={false}
                                className={"fb-40 border-none"}
                                header={this.renderHeader()}
                                bordered
                                footer={null}
                                dataSource={this.props.values.toJS().slice(0, this.state.initialLoadCount)}
                                renderItem={this.renderListItem}

                                // dataSource={this.props.values}
                                // renderItem={this.renderListItem}
                                loadMore={
                                    <Button disabled={this.props.values.size < 20} onClick={this.handleLoadMore} type="primary">
                                        Load more
                                    </Button>
                                }

                            />
                            <div className={"fb-60 pl-10"}>
                                <Card
                                    className={
                                        "no-shadow border-none top-0 pos-sticky"
                                    }
                                    bordered={false}>
                                    <DocumentViewer
                                        // key={_.id}
                                        width={"100%"}
                                        height={600}
                                        isInvoice={true}
                                        url={
                                            this.props.values.getIn([this.state.currentImageIndex, "file_url"])
                                        }
                                    />
                                </Card>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            </>
        );
    }
}


CompanyInvoiceFormList.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    loading: PropTypes.bool,
    toggleModal: PropTypes.func,
    isChecker: PropTypes.bool,
    invoiceValuesSubmit: PropTypes.func,
    isEditable: PropTypes.bool,
    finalSubmission: PropTypes.func,
    onRemove: PropTypes.func,
    dealerCodes: PropTypes.object,
    history: PropTypes.object,
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map(val => {
                    return new OrderedMap(val).set("principal_amount", val.principal_amount || val.amount)
                        .map((value, key) => {
                            let message = null;
                            if (key !== "dealer_code") {
                                if (!value) {
                                    message = "Field cannot be empty";
                                }
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        });
                })
                .toJS();
    }
})(CompanyInvoiceFormList);